import styled from 'styled-components';

export const ListLinksStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-right: 60px;

  div {
    display: flex;
  }

  h3 {
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    font-size: 24px;
    margin: 0;
    font-weight: 300;
  }
`;

export const WrapperLinks = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 300;

  ul {
    margin: 5px 25px 15px 15px;
    padding: 5px;
    a {
      text-decoration: none;
      color: ${({ theme }) => {
        return theme.colors.primary;
      }};
    }
  }
`;
